import { Component, EventEmitter, Input, NgZone, Output, OnChanges, OnInit, ViewChild } from '@angular/core';
import { formatDate } from '@angular/common';
//import { forkJoin, of, Observable } from 'rxjs';
import { take } from 'rxjs/operators';
//import { Action } from 'rxjs/internal/scheduler/Action';
import { DataStateChangeEvent, GridComponent, GridDataResult, RowClassArgs } from '@progress/kendo-angular-grid';
import { orderBy, process, State } from '@progress/kendo-data-query';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ConfirmDialog } from '../modals/confirm-dialog.component';
import { ApplicationControlService } from '../../services/applicationcontrol.service';
//import { DataService } from '../../services/data.service';
import { EmployeeService } from '../../services/employees.service';
import { NotificationService } from '../../services/notification.service';
import { OrderService } from '../../services/order.service';
import { RecordLockService } from '../../services/recordlock.service';
import { UtilService } from '../../services/util.service';
import {
    AddOrderStop
    , CheckCall
    , OrderEventSchedule
    , OrderEventType
    , OrderStop
    , QuoteOrderLine
    , SearchOrderStop
} from '../../models/models';

@Component({
    selector: 'order-stop-grid',
    templateUrl: './order-stop-grid.component.html',
    standalone: false
})
export class OrderStopGrid implements OnInit, OnChanges {
    @Input() orderNumber: string = "";
    @Input() quoteOrderLineID: number = 0;
    @Input() quoteOrderID: number = 0;
    @Input() readonly: boolean = false;
    @Input() pageType: string = "";
    @Input() pageSize: string = "10";
    @Input() pageable: boolean = true;
    @Input() height: number | undefined;
    @Input() isBlankActionColumn: boolean = false;
    @Input() isHideSingleLegOrder: boolean = false;
    @Input() refreshDate: Date = new Date();
    @Output() onClick = new EventEmitter<any>();
    @Output() getQuoteOrderLineSplit = new EventEmitter<any>();
    @Output() addOrderStop = new EventEmitter<any>();
    @Output() onRefresh = new EventEmitter<any>();

    @ViewChild(GridComponent, { static: false }) public stopsGrid!: GridComponent;

    //private subAllEmployees: Subscription | undefined;
    //private subQuoteOrderLines: Subscription | undefined;

    public isVisible: boolean = true;
    public columns: string = "action,event,customer,miles,carrier,planned,actual,freight,refnum,instructions";
    //public allEmployees: Employee[] = [];
    public searchOrderStops: SearchOrderStop[] = [];
    public orderEventSchedule: OrderEventSchedule[] = [];
    //public orderStops: OrderStop[] = [];
    private orderEventTypes: OrderEventType[] = [];
    public quoteOrderLines: QuoteOrderLine[] = [];
    public trackingCheckCall: CheckCall | undefined;
    public stopView: GridDataResult = { data: [], total: 0 };
    public stopState: State = { skip: 0, take: this.pageSize == "all" ? 0 : parseInt(this.pageSize), sort: [{ dir: 'asc', field: 'legNumber' }, { dir: 'asc', field: 'stopSequence' }] };
    public isHideCarrierColumn: boolean = false;
    public isSplit: boolean = false;
    public isAddStop: boolean = false;
    public isEditStop: boolean = false;
    public isShiftStop: boolean = false;
    public isSysAdmin: boolean = false;
    public isAccountManager: boolean = false;
    public isOpsRep: boolean = false;
    private lastStopID: number = 0;
    public orderStopID: number = 0;
    public shiftDays: number = 0;
    public shiftHours: number = 0;
    public newStop: AddOrderStop = {} as AddOrderStop;
    private addStopPlace: string = "";

    private isExportHub: boolean = false;

    public recordLockAction: string = "";
    public recordLockSource: string = "";

    constructor(private applicationControlService: ApplicationControlService,
        //private dataService: DataService,
        private employeeService: EmployeeService,
        private notificationService: NotificationService, private orderService: OrderService,
        private recordLockService: RecordLockService, private utilService: UtilService,
        public dialog: MatDialog, private ngZone: NgZone) {
    }

    ngOnInit() {
        this.getEmployeeInfo();
        this.getOrderEventTypes();
        this.isSysAdmin = this.getIsSysAdmin();
        this.isAccountManager = this.getIsAccountManager();
        this.isOpsRep = this.getIsOpsRep();
        //this.loadData();
        this.initRecordLock();
    }

    ngOnChanges() {
        this.applicationControlService.getApplicationControlsByAppName("ExportHub").subscribe(result => {
            if (result.length > 0) {
                if (result[0].appSettingValue == "1") {
                    this.isExportHub = true;
                }
                else {
                    this.isExportHub = false;
                }
            }
            this.loadData();
        });
        this.stopState.take = this.pageSize == "all" ? 0 : parseInt(this.pageSize);
    }

    private loadData() {
        this.init();
        //console.log("loadData", this.isVisible, this.isHideSingleLegOrder, this.orderNumber);
        this.configGrid();
        //if (this.isHideSingleLegOrder == true) {
        //    this.orderService.getSearchQuoteOrderLinesByOrderNumber(this.orderNumber);
        //}
        this.getQuoteOrderLines();
        this.getSearchOrderStops();
    }

    private init() {
        this.isEditStop = false;
        this.isAddStop = false;
        this.isShiftStop = false;
        this.addStopPlace = "";
        this.orderStopID = 0;
        this.newStop = {} as AddOrderStop;
        this.recordLockAction = "";
    }

    private getEmployeeInfo() {
        //this.employeeService.getAllEmployees().subscribe(result => {
        //    this.allEmployees = result;
        //});

        //    var name = "GetAllEmployees";
        //if (this.suballemployees) {
        //    this.suballemployees.unsubscribe();
        //}
        //var data = this.dataservice.get(name);
        //if (data) {
        //    this.allemployees = data.resultcollection;
        //    //console.log("allemployees", this.allemployees);
        //}
        //else {
        //    this.suballemployees = this.dataservice.currentdatacollection.subscribe(result => {
        //        if (result.name == name) {
        //            this.allemployees = result.resultcollection;
        //            //console.log("allemployees", this.allemployees);
        //        }
        //    });
        //}
    }

    private getIsSysAdmin() {
        var employeeRoles = localStorage.getItem('EmployeeRoles');

        //console.log(employeeRoles);
        if (employeeRoles != null && employeeRoles.length > 0) {
            if (employeeRoles.indexOf('System Admin') > -1) return true;
        }

        return false;
    }

    private getIsAccountManager() {
        var employeeRoles = localStorage.getItem('EmployeeRoles');

        //console.log(employeeRoles);
        if (employeeRoles != null && employeeRoles.length > 0) {
            if (employeeRoles.indexOf('Account Manager') > -1) return true;
        }

        return false;
    }

    private getIsOpsRep() {
        var employeeRoles = localStorage.getItem('EmployeeRoles');

        //console.log(employeeRoles);
        if (employeeRoles != null && employeeRoles.length > 0) {
            if (employeeRoles.indexOf('Ops Rep') > -1) return true;
        }

        return false;
    }

    private getOrderEventTypes() {
        this.orderService.getOrderEventTypes().subscribe(result => {
            this.orderEventTypes = result.resultCollection;
        });
    }

    private getQuoteOrderLines() {
        var name = "";
        if (this.quoteOrderID > 0) {
            //name = "getQuoteOrderLinesByQuoteOrderID-" + this.quoteOrderID;
            this.orderService.getQuoteOrderLinesByQuoteOrderID(this.quoteOrderID).subscribe(result => {
                this.quoteOrderLines = result.resultCollection;
            });
        }
        else if (this.quoteOrderLineID > 0) {
            //name = "GetQuoteOrderLineByID-" + this.quoteOrderLineID;
            this.orderService.getQuoteOrderLineById(this.quoteOrderLineID).subscribe(result => {
                var line: QuoteOrderLine = result;
                this.quoteOrderLines.push(line);
            });
        }
        else {
            //name = "getSearchQuoteOrderLinesByOrderNumber-" + this.orderNumber;
            this.orderService.getSearchQuoteOrderLinesByOrderNumber(this.orderNumber).subscribe(result => {
                this.quoteOrderLines = result.resultCollection;
            });
        }
    }

    public getReferenceNumbers(refNums: string) {
        if (refNums != null && refNums != "") {
            return refNums.split(",").join("<br />");
        }
        else {
            return "";
        }
    }

    private getSearchOrderStops() {
        this.utilService.isLoading = true;
        if (this.quoteOrderLineID > 0) {
            this.orderService.getSearchOrderStopsByQuoteOrderLineID(this.quoteOrderLineID).subscribe(result => {
                this.utilService.isLoading = false;
                this.setupStops(result.resultCollection);
            });
        }
        else if (this.quoteOrderID > 0) {
            this.orderService.getSearchOrderStopsByQuoteOrderID(this.quoteOrderID).subscribe(result => {
                this.utilService.isLoading = false;
                this.setupStops(result.resultCollection);
            });
        }
        else {
            this.orderService.getSearchOrderStopsByOrderNumber(this.orderNumber).subscribe(result => {
                this.utilService.isLoading = false;
                this.setupStops(result.resultCollection);
            });
        }
        //console.log("getSearchOrderStops", this.quoteOrderLineID, this.quoteOrderID);
    }

    private setupStops(col: any[]) {
        this.searchOrderStops = col;
        //this.sendERPData();
        this.setupStopData();
        //console.log("searchOrderStops", this.orderNumber, this.searchOrderStops);
    }

    //private sendERPData() {
    //    var idList: number[] = [];
    //    for (var i = 0; i < this.searchOrderStops.length; i++) {
    //        //var orderNumber = this.searchOrderStops[i].orderNumber;
    //        //var quoteOrderID = this.searchOrderStops[i].quoteOrderID;
    //        var externalOrderNumber = this.searchOrderStops[i].externalOrderNumber;
    //        var quoteOrderLineID = this.searchOrderStops[i].quoteOrderLineID;
    //        if (externalOrderNumber != null && externalOrderNumber != "") {
    //            // External Order
    //            var idx: number = idList.findIndex(t => t == quoteOrderLineID);
    //            if (idx < 0) {
    //                idList.push(quoteOrderLineID);
    //                this.updateERPByQuoteOrderLineID(quoteOrderLineID);
    //            }
    //        }
    //    }
    //    console.log("sendERPData", idList);
    //}

    private setupStopData() {
        var numCarrier = 0;
        var maxLegNum: number = 0;
        this.searchOrderStops.forEach(s => {
            s.earliestDate = new Date(s.earliestDate);
            s.latestDate = new Date(s.latestDate);
            s.arrivalDate = new Date(s.arrivalDate);
            s.departDate = new Date(s.departDate);
            if (s.carrierCode != null && s.carrierCode != "") {
                numCarrier++;
            }
            if (s.legNumber > maxLegNum) {
                maxLegNum = s.legNumber;
            }
        });
        if (this.isHideSingleLegOrder && maxLegNum < 2) {
            this.isVisible = false;
        }
        else {
            this.isVisible = true;
        }
        if (numCarrier == 0) {
            this.isHideCarrierColumn = true;
        }

        //console.log("setupStopData", maxLegNum, this.isHideSingleLegOrder, this.isVisible);

        this.getLastStopID();
        this.setOrderStopGrid();
    }

    private configGrid() {
        if (this.pageType == "carriersales" || this.pageType == "procurement") {
            this.columns = "action,event,customer,carrier,planned,freight,instructions";
        }
        else if (this.pageType == "orderentry") {
            this.columns = "action,event,customer,miles,carrier,planned,actual,freight,instructions,refnum";
        }
        else if (this.pageType == "tracking" || this.pageType == "crossborder") {
            this.columns = "action,event,customer,miles,carrier,planned,actual,freight,instructions,refnum";
        }
        //console.log("configGrid", this.pageType, this.columns);
    }

    private getLastStopID() {
        var lastStopID = 0;
        var quoteOrderLineId = 0;
        for (var i = 0; i < this.searchOrderStops.length; i++) {
            if (this.searchOrderStops[i].arrivedInd == true && this.searchOrderStops[i].departedInd == true) {
                lastStopID = this.searchOrderStops[i].orderStopID;
                quoteOrderLineId = this.searchOrderStops[i].quoteOrderLineID;
            }
            else if (this.searchOrderStops[i].arrivedInd == true && this.searchOrderStops[i].eventCode != "BMT") {
                lastStopID = this.searchOrderStops[i].orderStopID;
                quoteOrderLineId = this.searchOrderStops[i].quoteOrderLineID;
            }
        }
        this.lastStopID = lastStopID;
        //this.getOrderEventSchedule(quoteOrderLineId);
    }

    public canMoveDown(stop: SearchOrderStop) {
        var canMove = true;
        var nextStop = this.searchOrderStops.find(t => t.stopSequence == stop.stopSequence + 1);
        if (stop.orderStopID == this.lastStopID)
        {
            canMove = false;
        }
        else if (nextStop == null) {
            canMove = false;
        }
        else if (stop.quoteOrderLineID != nextStop!.quoteOrderLineID) {
            canMove = false;
        }
        return canMove;
    }

    public canMoveUp(stop: SearchOrderStop) {
        var canMove = true;
        var prevStop = this.searchOrderStops.find(t => t.stopSequence == stop.stopSequence - 1);
        if (stop.stopSequence == 1) {
            canMove = false;
        }
        else if (prevStop == null) {
            canMove = false;
        }
        else if (stop.quoteOrderLineID != prevStop!.quoteOrderLineID) {
            canMove = false;
        }
        return canMove;
    }

    public moveStopDown(stop: SearchOrderStop) {
        this.utilService.isLoading = true;
        var nextStop = this.searchOrderStops.find(t => t.stopSequence == stop.stopSequence + 1);
        if (nextStop != null) {
            this.utilService.setAuditNotes(this.utilService.getPageTypeName(this.pageType) + ": Stops Grid Swap Stops - Move Down");
            this.orderService.swapOrderStops(stop.orderStopID, nextStop.orderStopID).subscribe(result => {
                this.utilService.isLoading = false;
                this.loadData();
            });
        }
        else {
            this.notificationService.showError("Error moving stop down: next stop not found", "ERROR: Move Stop Down");
        }
    }

    public moveStopUp(stop: SearchOrderStop) {
        this.utilService.isLoading = true;
        var prevStop = this.searchOrderStops.find(t => t.stopSequence == stop.stopSequence - 1);
        if (prevStop != null) {
            this.utilService.setAuditNotes(this.utilService.getPageTypeName(this.pageType) + ": Stops Grid Swap Stops - Move Up");
            this.orderService.swapOrderStops(stop.orderStopID, prevStop.orderStopID).subscribe(result => {
                this.utilService.isLoading = false;
                this.loadData();
            });
        }
        else {
            this.notificationService.showError("Error moving stop up: previous stop not found", "ERROR: Move Stop Up");
        }
    }

    public canUnactualizeStop(stop: SearchOrderStop) {
        return stop.orderStopID == this.lastStopID;
    }

    public editOrderStop(stop: SearchOrderStop) {
        this.orderStopID = stop.orderStopID;
        if (this.pageType != "tracking" && this.pageType != "crossborder") {
            this.recordLockAction = "editOrderStop";
            //this.handleRecordLock(stop.quoteOrderID);
            this.recordLockService.checkHasRecordLock("QuoteOrder", stop.quoteOrderID, this.recordLockSource);
        }
        else {
            this.isEditStop = true;
        }
    }

    public shiftOrderStop(stop: SearchOrderStop) {
        this.orderStopID = stop.orderStopID;
        if (this.pageType != "tracking" && this.pageType != "crossborder") {
            this.recordLockAction = "shiftOrderStop";
            //this.handleRecordLock(stop.quoteOrderID);
            this.recordLockService.checkHasRecordLock("QuoteOrder", stop.quoteOrderID, this.recordLockSource);
        }
        else {
            this.shiftDays = 0;
            this.shiftHours = 0;
            this.isShiftStop = true;
        }
    }

    public shiftOrderStopSave() {
        //var numDaysHours = this.shiftDays > 0 ? this.shiftDays * 24 : 0;
        //var numHours = this.shiftHours > 0 ? this.shiftHours : 0;
        var numDaysHours = this.shiftDays * 24;
        var numHours = this.shiftHours;
        var shiftHours = numDaysHours + numHours;
        this.utilService.setAuditNotes(this.utilService.getPageTypeName(this.pageType) + ": Stops Grid Shift Stops");
        this.utilService.isLoading = true;
        this.orderService.shiftOrderStop(this.orderStopID, shiftHours).subscribe(result => {
            this.utilService.isLoading = false;
            this.isShiftStop = false;
            if (result.message != "OK") {
                this.notificationService.showError("Error shifting stop hours: " + result.message, "ERROR: Shift Stop Hours");
            }
            else {
                this.notificationService.showSuccess("Successfully shifted stop hours", "SUCCESS: Shift Stop Hours");
                var stop = this.searchOrderStops.find(t => t.orderStopID == this.orderStopID);
                this.addShiftStopCheckCall(stop!);
                console.log("shiftOrderStopSave", result, this.orderStopID);
            }
            this.loadData();
            this.onRefresh.emit();
        });
    }

    public deleteSplit(stop: SearchOrderStop) {
        this.orderStopID = stop.orderStopID;
        this.recordLockAction = "deleteSplit";
        //this.handleRecordLock(stop.quoteOrderID);
        this.recordLockService.checkHasRecordLock("QuoteOrder", stop.quoteOrderID, this.recordLockSource);
    }

    private allowDeleteSplit(stop: SearchOrderStop) {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = false;
        dialogConfig.autoFocus = true;
        dialogConfig.data = {
            header: 'Delete?',
            message: 'You are about to delete this split: ' + stop.eventCode + '. This will remove this location and join the two loads together.  Confirm to continue.'
        }

        const dialogRef = this.dialog.open(ConfirmDialog, dialogConfig);

        dialogRef.afterClosed().subscribe(dialogResult => {
            if (!dialogResult) return;

            this.utilService.setAuditNotes(this.utilService.getPageTypeName(this.pageType) + ": Stops Grid Delete Split");
            this.utilService.isLoading = true;
            this.orderService.deleteQuoteOrderLineSplit(stop.quoteOrderLineID).subscribe(result => {
                this.utilService.isLoading = false;
                if (result.message != "OK") {
                    this.notificationService.showError("Error deleting split: " + result.message, "ERROR: Delete Split");
                }
                else {
                    this.notificationService.showSuccess("Successfully deleted split", "SUCCESS: Delete Split");
                    console.log("deleteSplit", result, stop);
                }
                this.loadData();
                this.onRefresh.emit();
            });
        });
    }

    public deleteOrderStop(stop: SearchOrderStop) {
        this.orderStopID = stop.orderStopID;
        this.recordLockAction = "deleteOrderStop";
        //this.handleRecordLock(stop.quoteOrderID);
        this.recordLockService.checkHasRecordLock("QuoteOrder", stop.quoteOrderID, this.recordLockSource);
    }

    private allowDeleteOrderStop(stop: SearchOrderStop) {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = false;
        dialogConfig.autoFocus = true;
        dialogConfig.data = {
            header: 'Delete?',
            message: 'You are about to delete this stop: ' + stop.eventCode + '.  Confirm to continue.'
        }

        const dialogRef = this.dialog.open(ConfirmDialog, dialogConfig);

        dialogRef.afterClosed().subscribe(dialogResult => {
            if (!dialogResult) return;

            this.utilService.setAuditNotes(this.utilService.getPageTypeName(this.pageType) + ": Stops Grid Delete Stop");
            this.utilService.isLoading = true;
            this.orderService.deleteOrderStop(stop.orderStopID).subscribe(result => {
                this.utilService.isLoading = false;
                if (result.message != "OK") {
                    this.notificationService.showError("Error deleting stop: " + result.message, "ERROR: Delete Stop");
                }
                else {
                    this.notificationService.showSuccess("Successfully deleted stop", "SUCCESS: Delete Stop");
                    console.log("deleteOrderStop", result, stop);
                }
                this.loadData();
                this.onRefresh.emit();
            });
        });
    }

    public stopRemoveHandler({ sender, rowIndex, dataItem, isNew }) {
        //console.log("stopRemoveHandler", dataItem);
        this.orderStopID = dataItem.orderStopID;
        this.recordLockAction = "stopRemoveHandler";
        //this.handleRecordLock(dataItem.quoteOrderID);
        this.recordLockService.checkHasRecordLock("QuoteOrder", dataItem.quoteOrderID, this.recordLockSource);
    }

    private allowStopRemoveHandler(stop: SearchOrderStop) {
        // This is for Unactualizing a stop Arrival or Depart
        var thisStop: SearchOrderStop = Object.assign({}, stop);
        var orderStopIndex = this.searchOrderStops.findIndex(o => o.orderStopID == thisStop.orderStopID);
        if (orderStopIndex == null || orderStopIndex < 0) return;

        this.utilService.isLoading = true;
        this.orderService.getOrderEventScheduleByQuoteOrderLineId(thisStop.quoteOrderLineID).subscribe(schedResult => {
            this.utilService.isLoading = false;
            var codeType = "";
            if (thisStop.departedInd == true) {
                codeType = "Dep";
            }
            else if (thisStop.arrivedInd == true) {
                codeType = "Arv";
            }

            const dialogConfig = new MatDialogConfig();
            dialogConfig.disableClose = false;
            dialogConfig.autoFocus = true;
            dialogConfig.data = {
                header: 'Unactualize?',
                message: 'Would you like to unactualize the stop ' + thisStop.eventCode + '-' + codeType + '?'
            }

            const dialogRef = this.dialog.open(ConfirmDialog, dialogConfig);

            this.orderEventSchedule = schedResult.resultCollection;

            this.orderEventSchedule = this.orderEventSchedule.sort((left, right): number => {
                if (left.orderEventSequence < right.orderEventSequence) return -1;
                if (left.orderEventSequence > right.orderEventSequence) return 1;
                return 0;
            });

            this.orderEventSchedule.forEach(s => {
                var eventType = this.orderEventTypes.find(t => t.orderEventTypeID == s.orderEventTypeID)!;
                s.orderEventDate = new Date(s.orderEventDate);
                s.completedDate = new Date(s.completedDate);
                s.code = eventType.code;
            });

            dialogRef.afterClosed().subscribe(dialogResult => {
                if (!dialogResult) return;

                var schedList = this.orderEventSchedule.filter(o =>
                    o.orderStopID == thisStop.orderStopID
                    && o.code == thisStop.eventCode + '-' + codeType
                );
                if (schedList.length == 1) {
                    //var sched: OrderEventSchedule = JSON.parse(JSON.stringify(schedList[0]));
                    var sched: OrderEventSchedule = Object.assign({}, schedList[0]);
                    sched.completed = false;
                    if (thisStop.departedInd == true) {
                        sched.orderStop.departedInd = false;
                    }
                    else if (thisStop.arrivedInd == true) {
                        sched.orderStop.arrivedInd = false;
                    }
                    this.utilService.isLoading = true;
                    //console.log(sched);
                    sched.orderEventDate = this.utilService.getDateAsUTC(sched.orderEventDate);
                    if (sched.nextETADate != null) {
                        sched.nextETADate = this.utilService.getDateAsUTC(sched.nextETADate);
                    }
                    if (sched.completedDate != null) {
                        sched.completedDate = this.utilService.getDateAsUTC(sched.completedDate);
                    }
                    this.utilService.setAuditNotes(this.utilService.getPageTypeName(this.pageType) + ": Stops Grid Unactualize");
                    this.orderService.saveOrderEventScheduleUnactualize(sched).subscribe(result => {
                        this.utilService.isLoading = false;
                        if (result.message != "OK") {
                            this.notificationService.showError("Error unactualizing stop: " + result.message, "ERROR: Unactualize Stop");
                        }
                        this.addUnactualizedEventCheckCall(sched);
                        //this.setStops();
                        this.loadData();
                        this.onRefresh.emit();
                    });
                }
                else {
                    // No schedule entry found for this stop
                    this.orderService.getOrderStopByID(thisStop.orderStopID).subscribe(stopResult => {
                        var updateStop: OrderStop = stopResult.resultCollection[0];
                        //if (updateStop.departedInd == true) {
                        //    updateStop.departedInd = false;
                        //}
                        //else if (updateStop.arrivedInd == true) {
                        //    updateStop.arrivedInd = false;
                        //}
                        this.utilService.setAuditNotes(this.utilService.getPageTypeName(this.pageType) + ": Stops Grid Unactualize");
                        this.utilService.isLoading = true;
                        //updateStop.earliestDate = this.utilService.getDateAsUTC(updateStop.earliestDate);
                        //updateStop.latestDate = this.utilService.getDateAsUTC(updateStop.latestDate);
                        //updateStop.arrivalDate = this.utilService.getDateAsUTC(updateStop.arrivalDate);
                        //updateStop.departDate = this.utilService.getDateAsUTC(updateStop.departDate);
                        //console.log("stopRemoveHandler", updateStop);
                        this.orderService.saveOrderStopUnactualize(updateStop.orderStopId, this.utilService.getEmployeeID()).subscribe(result => {
                            this.utilService.isLoading = false;
                            if (result.message != "OK") {
                                this.notificationService.showError("Error unactualizing stop: " + result.message, "ERROR: Unactualize Stop");
                            }
                            this.addUnactualizedStopCheckCall(updateStop);
                            //this.setStops();
                            this.loadData();
                            this.onRefresh.emit();
                        });
                    });
                }
            });
        });
    }

    private setOrderStopGrid() {
        if (this.stopState.sort) {
            this.searchOrderStops = orderBy(this.searchOrderStops, this.stopState.sort);
        }

        this.stopView = process(this.searchOrderStops, this.stopState);
        this.fitStopColumns();
        //console.log("setOrderStopGrid", this.searchOrderStops, this.stopState);
    }

    private fitStopColumns() {
        this.ngZone.onStable.asObservable().pipe(take(1)).subscribe(() => {
            if (this.stopsGrid == null) return;

            //this.stopsGrid.autoFitColumns();
            var refNumColumn = this.stopsGrid.columnList.filter(c => c.title == 'Ref #');
        });
    }

    public stopDataStateChange(state: DataStateChangeEvent): void {
        this.stopState = state;
        this.setOrderStopGrid();
    }

    private addUnactualizedEventCheckCall(sched: OrderEventSchedule) {
        //console.log("addUnactualizedEventCheckCall", sched, this.quoteOrderLines);
        var quoteOrderLine = this.quoteOrderLines.find(q => q.quoteOrderLineID == sched.quoteOrderLineID); //sched.quoteOrderLine; 
        //this.trackingCheckCall = this.getNewCheckCall(quoteOrderLine!, sched.orderStop.eventCode);
        var eventType = this.orderEventTypes.find(t => t.orderEventTypeID == sched.orderEventTypeID)!;
        this.trackingCheckCall = this.getNewCheckCall(quoteOrderLine!, eventType.code);
        this.trackingCheckCall.orderEventScheduleID = sched.orderEventScheduleID;
        this.trackingCheckCall.checkCallAction = "Unactualized";
        var modifiedByName = localStorage.getItem('EmployeeFullName')!;
        var eventDate = formatDate(sched.completedDate, "MMM d yyyy h:mmaaa", "en-US");
        this.trackingCheckCall.comment = sched.code + ": Unactualized by " + modifiedByName + " @ " + eventDate;
        this.saveCheckCall(this.trackingCheckCall, true);
    }

    private addUnactualizedStopCheckCall(stop: OrderStop) {
        var quoteOrderLine = this.quoteOrderLines.find(q => q.quoteOrderLineID == stop.quoteOrderLineId);
        var eventCodeSuffix = "-Arv";
        if (stop.arrivedInd == true && stop.departedInd != true) {
            eventCodeSuffix = "-Dep";
        }
        this.trackingCheckCall = this.getNewCheckCall(quoteOrderLine!, stop.eventCode + eventCodeSuffix);
        this.trackingCheckCall.orderEventScheduleID = 0;
        this.trackingCheckCall.checkCallAction = "Unactualized";
        var modifiedByName = localStorage.getItem('EmployeeFullName')!;
        var modifiedDate = formatDate(new Date(), "MMM d yyyy h:mmaaa", "en-US");
        this.trackingCheckCall.comment = stop.eventCode + ": Unactualized by " + modifiedByName + " @ " + modifiedDate;
        this.saveCheckCall(this.trackingCheckCall, true);
    }

    private addShiftStopCheckCall(stop: SearchOrderStop) {
        var quoteOrderLine = this.quoteOrderLines.find(q => q.quoteOrderLineID == stop.quoteOrderLineID);
        this.trackingCheckCall = this.getNewCheckCall(quoteOrderLine!, stop.eventCode);
        this.trackingCheckCall.orderEventScheduleID = 0;
        this.trackingCheckCall.checkCallAction = "Shift Stops";
        var modifiedByName = localStorage.getItem('EmployeeFullName')!;
        var modifiedDate = formatDate(new Date(), "MMM d yyyy h:mmaaa", "en-US");
        this.trackingCheckCall.comment = stop.eventCode + ": Stops Shifted by " + modifiedByName + " @ " + modifiedDate;
        this.saveCheckCall(this.trackingCheckCall, true);
    }

    public getNewCheckCall(quoteOrderLine: QuoteOrderLine, eventCode: string) {
        var stop = this.searchOrderStops.filter(t => t.quoteOrderLineID == quoteOrderLine.quoteOrderLineID)[0];
        var newCheckCall = {
            quoteOrderLineId: quoteOrderLine.quoteOrderLineID,
            legHeaderNumber: quoteOrderLine.apiLoadID == null ? 0 : quoteOrderLine.apiLoadID,
            status: 'HIST',
            assignType: 'CAR',
            //assignId: (quoteOrderLine.carrierID > 0 ? quoteOrderLine.carrier.carrierCode : ''),
            assignId: (stop.carrierID > 0 ? stop.carrierCode : ''),
            cityId: 0,
            comment: '',
            dateOfCall: new Date(),
            eventCode: (eventCode != "" ? eventCode : "CHK"),
            tractorNumber: 'UNKNOWN',
            lateInd: false,
            cautionInd: false,
            createdByEmployeeId: this.utilService.getEmployeeID(),
            createdDate: new Date()
        } as CheckCall;
        return newCheckCall;
    }

    public saveCheckCall(checkCall: CheckCall, isUTCOffset: boolean) {
        this.utilService.isLoading = true;
        if (isUTCOffset) {
            checkCall.dateOfCall = this.utilService.getDateAsUTC(checkCall.dateOfCall);
        }
        this.orderService.saveCheckCall(checkCall).subscribe(result => {
            this.utilService.isLoading = false;
            //this.checkCalls.push(result);
            //this.setCheckCallGrid();
            //this.getCheckCalls();
        });
    }

    //private updateERPByQuoteOrderLineID(id: number) {
    //    if (!this.readonly) {
    //        this.applicationControlService.getApplicationControlsByAppName("ExportHub").subscribe(result => {
    //            if (result.length > 0) {
    //                if (result[0].appSettingValue == "1") {
    //                    this.isExportHub = true;
    //                }
    //                else {
    //                    this.isExportHub = false;
    //                }
    //            }
    //            if (this.isExportHub != true) {
    //                this.notificationService.showInfo("Updating TMW Stops ...", "TMW Update");
    //                this.orderService.updateERPOrderStopsByQuoteOrderLineId(id, "TMW").subscribe(result => {
    //                    var ok = result;
    //                    if (result.message != "OK") {
    //                        this.notificationService.showError("Error updating TMW: " + result.message, "ERROR: TMW Update");
    //                    }
    //                    else {
    //                        this.notificationService.showInfo("TMW Update Complete", "TMW Update");
    //                    }
    //                });
    //            }
    //        });
    //    }
    //}

    public splitLoad(stop: SearchOrderStop) {
        this.orderStopID = stop.orderStopID;
        this.recordLockAction = "splitLoad";
        //this.handleRecordLock(stop.quoteOrderID);
        this.recordLockService.checkHasRecordLock("QuoteOrder", stop.quoteOrderID, this.recordLockSource);
    }

    private allowSplitLoad(stop: SearchOrderStop) {
        var evt: any = {
            quoteOrderLineID: stop.quoteOrderLineID,
            orderStopID: stop.orderStopID
        };
        console.log("order-stop-grid:splitLoad", evt);
        this.getQuoteOrderLineSplit.emit(evt);
        this.isSplit = false;
    }

    public addStop(stop: SearchOrderStop, stopPlace: string) {
        this.orderStopID = stop.orderStopID;
        this.addStopPlace = stopPlace;
        this.recordLockAction = "addStop";
        //this.handleRecordLock(stop.quoteOrderID);
        this.recordLockService.checkHasRecordLock("QuoteOrder", stop.quoteOrderID, this.recordLockSource);
    }

    private allowAddStop(stop: SearchOrderStop, stopPlace: string) {
        //console.log("order-stop-grid:addStop", stopPlace, stop);
        this.utilService.isLoading = true;
        this.orderService.getOrderStopByID(stop.orderStopID).subscribe(result => {
            this.utilService.isLoading = false;
            //this.notificationService.showInfo("This feature is under development", "NOTE: Under Development");
            if (result.resultCollection.length > 0) {
                var currStop: OrderStop = result.resultCollection[0];
                //console.log("order-stop-grid:addOrderStop", currStop);
                this.newStop = {
                    stop: currStop,
                    searchStop: stop,
                    stopPlace: stopPlace
                }
                this.isAddStop = true;
            //    var col: AddOrderStop[] = [];
            //    col.push(addStop);
            //    var datCol: DataCollection = {
            //        name: "AddOrderStop-AddOrderStop",
            //        resultCollection: col
            //    }
            //    this.dataService.set(datCol);
            //    this.isAddStop = false;
            }
            else {
                this.notificationService.showError("Error finding stop info", "ERROR: Add Stop");
            }
        });
    }

    public canSplitAfter(stop: SearchOrderStop) {
        var canSplit: boolean = false;
        if (this.pageType == "orderentry" && this.isSplit) {
            var stops: SearchOrderStop[] = this.searchOrderStops.filter(t => t.legNumber == stop.legNumber);
            if (stops.length > 0 && stops[stops.length - 1].stopSequence > stop.stopSequence) {
                canSplit = true;
            }
        }
        return canSplit;
    }

    public canEditStop(stop: SearchOrderStop) {
        var canEdit: boolean = false;
        if (
            (this.pageType == "orderentry" || this.pageType == "tracking" || this.pageType == "crossborder")
            && !this.isSplit
            && !this.isAddStop) {
            canEdit = true;
        }
        return canEdit;
    }

    public canShiftStop(stop: SearchOrderStop) {
        var canEdit: boolean = false;
        if (
            //(this.pageType == "orderentry" || this.pageType == "tracking")
            this.pageType == "orderentry"
            && (this.isAccountManager == true || this.isOpsRep == true)
            && stop.arrivedInd != true
            && stop.departedInd != true
            //&& stop.hasAppointment != true
            && !this.isSplit
            && !this.isAddStop) {
            canEdit = true;
        }
        return canEdit;
    }

    public canDeleteSplit(stop: SearchOrderStop) {
        var canDeleteSplit: boolean = false;
        if (this.pageType == "orderentry" && !this.isSplit && !this.isAddStop
            && stop.arrivedInd != true && stop.departedInd != true
            && stop.legNumber > 1) {
            var stops: SearchOrderStop[] = this.searchOrderStops.filter(t =>
                t.stopSequence == stop.stopSequence - 1
                && t.legNumber == stop.legNumber - 1);
            if (stops.length > 0) {
                canDeleteSplit = true;
            }
        }
        return canDeleteSplit;
    }

    public canDeleteStop(stop: SearchOrderStop) {
        var canDeleteStop: boolean = false;
        if (this.pageType == "orderentry" && !this.isSplit && !this.isAddStop
            && stop.arrivedInd != true && stop.departedInd != true) {
            var stops: SearchOrderStop[] = this.searchOrderStops.filter(t =>
                t.legNumber == stop.legNumber
                && (t.stopSequence == stop.stopSequence - 1 || t.stopSequence == stop.stopSequence + 1));
            if (stops.length == 2) {
                canDeleteStop = true;
            }
        }
        return canDeleteStop;
    }

    public canAddStopAfter(stop: SearchOrderStop) {
        var canAddStop: boolean = false;
        if (this.pageType == "orderentry") {
            var stops: SearchOrderStop[] = this.searchOrderStops.filter(t => t.legNumber == stop.legNumber);
            if (stops.length > 0 && stops[stops.length - 1].stopSequence > stop.stopSequence) {
                canAddStop = true;
            }
        }
        return canAddStop;
    }

    public stopRowCallback = (context: RowClassArgs) => {
        var stop = context.dataItem as SearchOrderStop;
        if (stop.arrivalDate > stop.latestDate) {
            return 'text-danger font-weight-bold'
        }
    }

    public refreshAfterEdit() {
        if (this.quoteOrderLines.length > 0 && this.pageType != "orderentry" && this.pageType != "tracking" && this.pageType != "crossborder") {
            this.recordLockService.clearRecordLock("QuoteOrder", this.quoteOrderLines[0].quoteOrderID, this.recordLockSource);
            //this.recordLockService.clearRecordLock(this.recordLockService.recordLock.recordLockID);
        }
        //console.log("refreshAfterEdit");
        this.refreshDate = new Date();
        this.loadData();
        this.onRefresh.emit();
    }

    public cancelEdit() {
        this.init();
        //console.log("order-stop-grid:cancelEdit:isLocked", this.recordLockService.isLocked);
        if (this.quoteOrderLines.length > 0 && this.pageType != "orderentry" && this.pageType != "tracking" && this.pageType != "crossborder" && !this.recordLockService.isLocked) {
            this.recordLockService.clearRecordLock("QuoteOrder", this.quoteOrderLines[0].quoteOrderID, this.recordLockSource);
            //this.recordLockService.clearRecordLock(this.recordLockService.recordLock.recordLockID);
        }
    }

    private initRecordLock() {
        this.recordLockAction = "";
        this.recordLockSource = "Stops Grid";
        if (this.pageType == "orderentry") {
            //this.recordLockSource = "Order Entry: Stops Grid";
            this.recordLockSource = "Order Entry";
        }
        else if (this.pageType == "carriersales" || this.pageType == "procurement") {
            //this.recordLockSource = "Procurement: Stops Grid";
            this.recordLockSource = "Procurement";
        }
        else if (this.pageType == "tracking") {
            this.recordLockSource = "Tracking Dashboard";
        }
        else if (this.pageType == "crossborder") {
            this.recordLockSource = "Cross Border";
        }

        this.recordLockService.hasRecordLockObserver.subscribe(result => {
            //console.log("order-stop-grid:handleRecordLock:isContinueRecorLock", this.recordLockService.isContinueRecordLock);
            if (this.recordLockService.hasRecordLock) {
                if (this.recordLockAction == "editOrderStop") {
                    this.isEditStop = true;
                }
                else if (this.recordLockAction == "shiftOrderStop") {
                    this.shiftDays = 0;
                    this.shiftHours = 0;
                    this.isShiftStop = true;
                }
                else if (this.recordLockAction == "deleteOrderStop") {
                    var stop = this.searchOrderStops.find(t => t.orderStopID == this.orderStopID);
                    if (stop != null) {
                        this.allowDeleteOrderStop(stop);
                    }
                }
                else if (this.recordLockAction == "deleteSplit") {
                    var stop = this.searchOrderStops.find(t => t.orderStopID == this.orderStopID);
                    if (stop != null) {
                        this.allowDeleteSplit(stop);
                    }
                }
                else if (this.recordLockAction == "splitLoad") {
                    var stop = this.searchOrderStops.find(t => t.orderStopID == this.orderStopID);
                    if (stop != null) {
                        this.allowSplitLoad(stop);
                    }
                }
                else if (this.recordLockAction == "addStop") {
                    var stop = this.searchOrderStops.find(t => t.orderStopID == this.orderStopID);
                    if (stop != null) {
                        this.allowAddStop(stop, this.addStopPlace);
                    }
                }
                else if (this.recordLockAction == "stopRemoveHandler") {
                    var stop = this.searchOrderStops.find(t => t.orderStopID == this.orderStopID);
                    if (stop != null) {
                        this.allowStopRemoveHandler(stop);
                    }
                }
                this.recordLockAction = "";
            }
        });
    }
}
